import { input } from '../../Commons/input';
import { button } from '../../Commons/button';
import { media } from '../../theme';

export const setNewPassword = {
  backstage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: '#E1E1E1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: '90%',
    height: '380px',
    maxWidth: '400px',
    display: 'grid',
    gridTemplateColumns: '5% 90% 5%',
    gridTemplateRows: '15% 15% 50% auto',
    gridTemplateAreas: `
      '. . .'
      '. a .'
      '. b .'
      '. c .'
    `,
    alignItems: 'center',
    backgroundColor: 'white',
    boxShadow: '0 11px 32px 2px rgba(0,0,0,0.1)',
    zIndex: 10,
    [media.desktop]: {
      width: '550px',
      maxWidth: '630px',
      gridTemplateColumns: '15% 70% 15%',
      gridTemplateRows: '15% 20% 40% auto',
    },
  },
  title: {
    gridArea: 'a',
    justifySelf: 'center',
    alignSelf: 'start',
    fontFamily: 'Roboto',
    fontSize: '1.125rem',
    fontWeight: '500',
    textTransform: 'uppercase',
    [media.desktop]: {
      fontSize: '1.75rem',
      textTransform: 'none',
    },
  },
  form: {
    gridArea: 'b',
    alignSelf: 'start',
    justifySelf: 'center',
    width: '100%',
  },
  inputContainer: {
    ...input.container,
    [media.desktop]: {
      ...input.container[media.desktop],
      gridTemplateColumns: '100%',
      gridTemplateRows: '2.25rem auto',
      gridTemplateAreas: `
        'b'
        'c'
      `,
    },
  },
  inputLabel: { ...input.label },
  input: { ...input.input },
  inputError: { ...input.error },
  ok: {
    ...button.yellow,
    gridArea: 'c',
    alignSelf: 'start',
    justifySelf: 'center',
    [media.mobile]: {
      width: '60%',
    },
    [media.desktop]: {
      ...button.yellow[media.desktop],
      width: '13rem',
    },
  },
  backError: {
    gridArea: 'c',
    width: '100%',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: '300',
    color: 'red',
    marginTop: '3rem',
  },
};
